import "./index.css";

export default function AvailableStatus({ status, customCls }) {
  return (
    <p className={`avlstatus-comp-para ${customCls ? customCls : ""}`}>
      {status}
    </p>
  );
}
